module.exports = __webpack_public_path__ + "arrow_product@2x.png?01977144ad73c47a21cfa99088a7bcc1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow_product@2x.png
// module id = 162
// module chunks = 0